export { type GraphemeTwData, graphemeTwDataTable } from "#grapheme-tw-data-table";
